export const updateContentHeight = (tabsVisible: boolean) => {
    document.documentElement.classList.toggle("static-tabs", tabsVisible);
};
